import { render, staticRenderFns } from "./AlterationReferencesABP.vue?vue&type=template&id=ba717a42&scoped=true&"
import script from "./AlterationReferencesABP.vue?vue&type=script&lang=js&"
export * from "./AlterationReferencesABP.vue?vue&type=script&lang=js&"
import style0 from "./AlterationReferencesABP.vue?vue&type=style&index=0&id=ba717a42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba717a42",
  null
  
)

export default component.exports